import { map } from "rxjs";

import { Organization } from "@box/common/admin-console/models/domain/organization";
import { Provider } from "@box/common/admin-console/models/domain/provider";
import { Account } from "@box/common/auth/abstractions/account.service";

export type BoxSubscriber =
  | { type: "account"; data: Account }
  | { type: "organization"; data: Organization }
  | { type: "provider"; data: Provider };

export type NonIndividualSubscriber = Exclude<BoxSubscriber, { type: "account" }>;

export const mapAccountToSubscriber = map<Account | null, BoxSubscriber>((account) => {
  if (!account) {
    throw new Error("Account not found");
  }
  return {
    type: "account",
    data: account,
  };
});

export const mapOrganizationToSubscriber = map<Organization | undefined, BoxSubscriber>(
  (organization) => {
    if (!organization) {
      throw new Error("Organization not found");
    }
    return {
      type: "organization",
      data: organization,
    };
  },
);

export const mapProviderToSubscriber = map<Provider | null, BoxSubscriber>((provider) => {
  if (!provider) {
    throw new Error("Organization not found");
  }
  return {
    type: "provider",
    data: provider,
  };
});
